/* Al Basha Silver - country picker on first visit (added by Claude, 17 Oct 2026; key bumped 25 Oct 2026 so every visitor sees it once again).
   Prices: Shopify Markets now shows each Gulf country's own currency natively,
   so the old manual price conversion that lived in this file is turned off
   (it converted a second time and broke prices, e.g. Qatari riyal). */
(function () {
  if (window.__bsCountryPicker) return;
  window.__bsCountryPicker = true;
  var KEY = 'bs_country_chosen_v2';
  var COUNTRIES = [
    { code: 'AE', flag: '🇦🇪', ar: 'الإمارات', en: 'UAE', cur: 'AED', noteAr: 'توصيل مجاني خلال 24-48 ساعة · دفع عند الاستلام', noteEn: 'Free delivery in 24-48h · Cash on delivery' },
    { code: 'SA', flag: '🇸🇦', ar: 'السعودية', en: 'Saudi Arabia', cur: 'SAR' },
    { code: 'KW', flag: '🇰🇼', ar: 'الكويت', en: 'Kuwait', cur: 'KWD' },
    { code: 'QA', flag: '🇶🇦', ar: 'قطر', en: 'Qatar', cur: 'QAR' },
    { code: 'BH', flag: '🇧🇭', ar: 'البحرين', en: 'Bahrain', cur: 'BHD' },
    { code: 'OM', flag: '🇴🇲', ar: 'عُمان', en: 'Oman', cur: 'OMR' }
  ];
  var GCC_NOTE_AR = 'شحن سريع خلال 5-7 أيام · دفع آمن بالبطاقة أو تقسيط مع تابي وتمارا';
  var GCC_NOTE_EN = 'Fast shipping in 5-7 days · Secure card payment or instalments with Tabby & Tamara';

  function storageGet() { try { return window.localStorage.getItem(KEY); } catch (e) { return '1'; } }
  function storageSet() { try { window.localStorage.setItem(KEY, '1'); } catch (e) {} }

  function currentCountry() {
    if (window.BS_COUNTRY) return window.BS_COUNTRY;
    if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    return 'AE';
  }

  function choose(code) {
    storageSet();
    if (code === currentCountry()) { close(); return; }
    var f = document.createElement('form');
    f.method = 'post';
    f.action = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'localization';
    var fields = { form_type: 'localization', utf8: '✓', country_code: code, return_to: window.location.pathname + window.location.search };
    for (var k in fields) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = k; i.value = fields[k];
      f.appendChild(i);
    }
    document.body.appendChild(f);
    f.submit();
  }

  var overlay;
  function close() { if (overlay) { overlay.remove(); overlay = null; } document.documentElement.style.overflow = ''; }

  function open() {
    var isAr = (document.documentElement.lang || 'ar').indexOf('ar') === 0;
    var style = document.createElement('style');
    style.textContent =
      '.bs-cp{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.72);display:flex;align-items:center;justify-content:center;padding:16px;}' +
      '.bs-cp__box{background:#0d0d0d;color:#fff;border:1px solid rgba(201,169,110,.55);border-radius:18px;width:100%;max-width:440px;max-height:90vh;overflow-y:auto;padding:26px 20px 18px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.5);}' +
      '.bs-cp__title{font-size:2rem;margin:0 0 6px;color:#c9a96e;letter-spacing:.02em;}' +
      '.bs-cp__sub{font-size:1.35rem;opacity:.8;margin:0 0 18px;line-height:1.6;}' +
      '.bs-cp__list{display:grid;gap:10px;}' +
      '.bs-cp__opt{display:flex;align-items:center;gap:12px;width:100%;background:rgba(255,255,255,.05);border:1px solid rgba(201,169,110,.35);border-radius:12px;padding:12px 14px;color:#fff;cursor:pointer;font:inherit;text-align:start;transition:border-color .2s,background .2s;}' +
      '.bs-cp__opt:hover,.bs-cp__opt:focus-visible{border-color:#c9a96e;background:rgba(201,169,110,.12);outline:none;}' +
      '.bs-cp__flag{font-size:2.4rem;line-height:1;}' +
      '.bs-cp__txt{flex:1;display:flex;flex-direction:column;gap:3px;}' +
      '.bs-cp__name{font-size:1.55rem;font-weight:600;}' +
      '.bs-cp__note{font-size:1.15rem;opacity:.7;line-height:1.5;}' +
      '.bs-cp__cur{font-size:1.2rem;color:#c9a96e;white-space:nowrap;}';
    document.head.appendChild(style);

    overlay = document.createElement('div');
    overlay.className = 'bs-cp';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    var box = document.createElement('div');
    box.className = 'bs-cp__box';
    box.setAttribute('dir', isAr ? 'rtl' : 'ltr');

    var h = document.createElement('p');
    h.className = 'bs-cp__title';
    h.textContent = isAr ? 'اختاري دولتك' : 'Choose your country';
    var s = document.createElement('p');
    s.className = 'bs-cp__sub';
    s.textContent = isAr
      ? 'عشان تشوفي الأسعار بعملة دولتك وطرق التوصيل والدفع المتاحة لك'
      : 'See prices in your currency and the delivery and payment options available to you';
    box.appendChild(h);
    box.appendChild(s);

    var list = document.createElement('div');
    list.className = 'bs-cp__list';
    COUNTRIES.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bs-cp__opt';
      var flag = document.createElement('span'); flag.className = 'bs-cp__flag'; flag.textContent = c.flag;
      var txt = document.createElement('span'); txt.className = 'bs-cp__txt';
      var name = document.createElement('span'); name.className = 'bs-cp__name'; name.textContent = isAr ? c.ar : c.en;
      var note = document.createElement('span'); note.className = 'bs-cp__note';
      note.textContent = c.code === 'AE' ? (isAr ? c.noteAr : c.noteEn) : (isAr ? GCC_NOTE_AR : GCC_NOTE_EN);
      txt.appendChild(name); txt.appendChild(note);
      var cur = document.createElement('span'); cur.className = 'bs-cp__cur'; cur.textContent = c.cur;
      b.appendChild(flag); b.appendChild(txt); b.appendChild(cur);
      b.addEventListener('click', function () { choose(c.code); });
      list.appendChild(b);
    });
    box.appendChild(list);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
  }

  function start() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (/\/(checkouts?|cart|account)/.test(window.location.pathname)) return;
    if (storageGet()) return;
    open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
